import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import AssetClassificationsTable from "../../containers/domain/asset-classification/AssetClassificationsTable";

const AssetClassificationsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de Classificações de Ativos"
        content={<AssetClassificationsTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default AssetClassificationsListingView;
